import WebSocketManager from "../WebSocketManager/WebSocketManager";

export type OrderPacket = SinglePump | SequentialPump | DisplayText;

interface SinglePump {
    type: "single_pump";
    pumpId: number;
    quantity: number;
}

interface SequentialPump {
    type: "sequential_pump";
    delay: number;
    pumpIds: Array<number>;
    quantities: Array<number>;
}

interface DisplayText {
    type: "display_text";
    text: string;
}

class OrderManager {
    private webSocketManager: WebSocketManager<OrderPacket>;

    constructor(url: string) {
        this.webSocketManager = new WebSocketManager<OrderPacket>(url, 3000, { next: this.orderObserver });
    }

    private orderObserver(message: any) {
        console.log(message);
    }

    sendOrder(order: OrderPacket) {
        this.webSocketManager.send_packet(order);
    }

    is_connected() {
        return this.webSocketManager.is_connected();
    }
}

export default OrderManager;